// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1HR5q","info":"PatientInfo_info__DD0Fa"};